import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../../shared/auth/auth.service';

@Component({
  selector: 'app-refresh-password',
  templateUrl: './refresh-password.component.html',
  styleUrls: ['./refresh-password.component.scss']
})
export class RefreshPasswordComponent implements OnInit {
  resetPasswordForm!: FormGroup;
  isFormValid:boolean = false;
  userName: string = '';

  constructor(private fb: FormBuilder, public toastr: ToastrService, private authService: AuthService) { }

  ngOnInit(): void {
    this.userName = localStorage.getItem("username");
    this.CreateForm();
  }

  CreateForm() {
    this.resetPasswordForm = this.fb.group({
      userName: ['', [Validators.required]],
      password: ['', [Validators.required, passwordPatternValidator()]],
      confirmPassword: ['', [Validators.required, passwordPatternValidator()]],
      createdBy: [this.userName]
    }, {
      validators: passwordMatchValidator
    });
  }

  onResetPassword() {
    this.isFormValid = true;

    if (this.resetPasswordForm.invalid) {
      return;
    }

    this.authService.ResetPassword(this.resetPasswordForm.value).subscribe({
      next: (res: any) => {
        if (res) {
          this.toastr.success('Password has been updated.');
          this.isFormValid = false;
          this.CreateForm();
        }
        else {
          this.toastr.error('Something went wrong.');
        }
      },
      error: (err) => {
        const modelState = err.error.ModelState;
        if (modelState) {
          const firstKey = Object.keys(modelState)[0];
          const firstError = modelState[firstKey][0];
          this.toastr.error(firstError);
        }
        else {
          this.toastr.error(err.error.Message || 'Something went wrong.');
        }
      }
    });
  }
}

export function passwordPatternValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    if (control.value != '') {
      const password = control.value;
      const passwordPattern = /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[!@#\$%\^&\*]).{8,14}$/;
      if (!passwordPattern.test(password)) {
        return { invalidPassword: true };
      }
    }
    return null;
  };
}

export function passwordMatchValidator(control: AbstractControl) {
  const password = control.get('password')?.value;
  const confirmPassword = control.get('confirmPassword')?.value;

  if (password !== confirmPassword) {
    control.get('confirmPassword')?.setErrors({ passwordMismatch: true });
    return { passwordMismatch: true };
  } else {
    return null;
  }
}
